import FreestarAdSlot from "@freestar/pubfig-adslot-react-component";
import { useQuery } from "@apollo/client";
import { GET_USER_STATE } from "@ugg/shared/api/requests/accounts/user-state";

export const FREESTAR_PUBLISHER = "u-gg";

export enum FreestarPlacements {
  IabFoot1 = "u-gg_iab_foot1",
  LeaderboardATF = "u-gg_leaderboard_atf",
  MedRectATF = "u-gg_med_rect_atf",
  MedRectBTF = "u-gg_med_rect_btf",
  MedRectBTF2 = "u-gg_med_rect_btf2",
  OopFlex = "u-gg_oop-flex",
}

export const FreestarContainer = () => {
  const { loading, data } = useQuery(GET_USER_STATE);

  if (loading || data?.getState.premium.isPremium) {
    return null;
  }

  return (
    <FreestarAdSlot
      publisher={FREESTAR_PUBLISHER}
      placementName={FreestarPlacements.OopFlex}
      slotId="oop-flex"
    />
  );
};
